// Module
var code = "<div id=\"V-AA0C50FE-BC68-44C5-8B1D-1927CACFCF55\" style=\"background-color:#00f\"> </div> ";
// Exports
export default code;